import { render, staticRenderFns } from "./ScriptSection.vue?vue&type=template&id=31650030&"
import script from "./ScriptSection.vue?vue&type=script&lang=js&"
export * from "./ScriptSection.vue?vue&type=script&lang=js&"
import style0 from "./ScriptSection.vue?vue&type=style&index=0&id=31650030&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports